<template>
  <div></div>
<!--  <h1 :style="styleObj" class="com-title">-->
<!--    <i></i>{{ propsRouteName || routeName }}-->
<!--  </h1>-->
</template>

<script>
export default {
  name: "index",
  props: {
    styleObj: {
      type: Object,
      default() {
        return {
          fontSize: "16px",
          lineHeight: "36px",
          backgroundColor: "#fff",
          paddingLeft: "16px",
          fontWeight: "600",
          borderBottom: "solid 1px #E5E5E5"
        };
      }
    },
    // 接收名称传值，如果没有，则通过routeName计算属性获取
    propsRouteName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      routes: [
        {
          path: "/signInfo/signList?signStatus=2",
          routeName: "未完成"
        },
        {
          path: "/signInfo/signList?signStatus=3",
          routeName: "已结束"
        },
        {
          path: "/corp/signInfo/signList?signStatus=2",
          routeName: "未完成"
        },
        {
          path: "/corp/signInfo/signList?signStatus=3",
          routeName: "已结束"
        },
        {
          path: "/signInfo/signList",
          routeName: "收件箱"
        },
        {
          path: "/signInfo/applyList",
          routeName: "发件箱"
        },
        {
          path: "/signInfo/applyList?signStatus=4",
          routeName: "草稿箱"
        },
        {
          path: "/signInfo/arbitration",
          routeName: "广仲记录"
        },
        {
          path: "/signInfo/taiarbitration",
          routeName: "台州仲记录"
        },
        {
          path: "/signInfo/ganarbitration",
          routeName: "赣国仲记录"
        },
        {
          path: "/signInfo/zharbitration",
          routeName: "珠仲记录"
        },
        {
          path: "/signInfo/sjw",
          routeName: "债权变现"
        },
        {
          path: "/signInfo/safeguard",
          routeName: "出证订单"
        },
        {
          path: "/signInfo/viewDealTypeList",
          routeName: "保全存证"
        },
        {
          path: "/signInfo/entAccess?typeStatus=apiSet",
          routeName: "API签署管理"
        },
        {
          path: "/signInfo/entAccess?typeStatus=entAuth",
          routeName: "企业认证管理"
        },
        {
          path: "/signInfo/entAccess?typeStatus=signCallback",
          routeName: "签署回调"
        },
        {
          path: "/signInfo/entAccess?typeStatus=entSign",
          routeName: "企业认证回调"
        },
        {
          path: "/signInfo/entAccess?typeStatus=setUrl",
          routeName: "回调地址设置"
        },
        {
          path: "/tpl/general",
          routeName: "我的模板"
        },
        {
          path: "/tpl/authorization",
          routeName: "授权模板"
        },
        {
          path: "/tpl/api",
          routeName: "API模板"
        },
        {
          path: "/tpl/personSet",
          routeName: "印章管理"
        },
        {
          path: "/tpl/entSign",
          routeName: "印章管理"
        },
        {
          path: "/tpl/corpSet",
          routeName: "印章管理"
        },
        {
          path: "/tpl/signStatistics",
          routeName: "签署统计"
        },
        {
          path: "/tpl/digital",
          routeName: "数字证书授权"
        },
        {
          path: "/tpl/grant",
          routeName: "授权人设置"
        },
        {
          path: "/tpl/signPwd",
          routeName: "签署密码"
        },
        {
          path: "/signSettings/security/dc",
          routeName: "君子盾"
        },
        {
          path: "/signSettings/signers",
          routeName: "常用签署方"
        },
        {
          path: "/signSettings/accountInfo",
          routeName: "账户管理"
        }
      ]
    };
  },
  computed: {
    routeName() {
      let routes = this.$route.fullPath;
      for (let i = 0, length = this.routes.length; i < length; i++) {
        if (routes === this.routes[i].path) {
          return this.routes[i].routeName;
        }
        if (routes.indexOf(this.routes[i].path) != -1) {
          return this.routes[i].routeName;
        }
      }
      return "君子签";
    }
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// components/route-name/index.vue